import { deburr } from "lodash";

const BLOCK_ELEMENT_TAG_NAMES = ["P", "DIV"];

function wrapHighlightedString(string) {
  if (!string) return string;
  const htmlParser = document.createElement("div");
  htmlParser.innerHTML = string;
  const containsBlockHTML = Array.from(htmlParser.children).some(({ tagName }) =>
    BLOCK_ELEMENT_TAG_NAMES.includes(tagName)
  );
  const TagName = containsBlockHTML ? "div" : "span";
  return (
    <TagName
      className="highlighted-string"
      dangerouslySetInnerHTML={{ __html: string }}
    />
  );
}

export function highlight(string, terms) {
  // Do not process string if there are no terms to highlight
  if (!terms || !string) {
    return wrapHighlightedString(string);
  }

  // Ensure we have a default class name for our highlight span
  const replaceString = "<span class='highlight'>$1</span>";

  // Wrap terms into an array if a string is provided
  if (typeof terms === "string") {
    terms = [terms];
  }

  terms.forEach(term => {
    const searchRegex = new RegExp(`(${term})`, "ig");
    string = string.replace(searchRegex, replaceString);
  });

  return wrapHighlightedString(string);
}

// Borrowed from https://stackoverflow.com/a/30613599/685925
export function truncateCentered(string, maxLength = 30, separator = "...") {
  if (!string) return string;

  const length = string.length;

  if (length > maxLength) {
    const separatorLength = separator.length;

    if (separatorLength > maxLength) {
      return string.substr(length - maxLength);
    }

    const n = -0.5 * (maxLength - length - separatorLength);
    const center = length / 2;

    return string.substr(0, center - n) + separator + string.substr(length - center + n);
  }

  return string;
}

// Removes all accents from the provided string using the Lodash `deburr` function and
// converts the resulting string to lower case.
//
// This is useful to easen string comparison during search or sort operations.
//
export function normalizeString(string) {
  return deburr(string).toLowerCase();
}
